module.exports = __webpack_public_path__ + "static/media/26UNRWA21.5dcb0127.jpg";